import { useEffect, useState } from "react";

import {
  AiAssistantChatHistory,
  AiAssistantChatHistoryItem,
  AiAssistantChatMessageAuthor,
} from "types/aiAssistant";
import { showErrorModal } from "helpers";
import {
  addAiAssistantChatHistoryItem,
  clearAiAssistantChatHistory,
  createAiAssistantChatHistoryItem,
  getAiAssistantChatHistory,
  getAiAssistantChatId,
  setAiAssistantChatId,
} from "helpers/aiAssistant";

import {
  LangchainChatDto,
  mutationLangchainControllerChat,
  mutationLangchainControllerResumeGraph,
} from "utils/swagger_react_query";

export const useAiAssistant = () => {
  const [chatHistory, setChatHistory] = useState<AiAssistantChatHistory>([]);
  const [isLoading, setIsLoading] = useState(false);

  const chatId = getAiAssistantChatId();
  const chatHistoryLocalStorage = getAiAssistantChatHistory();

  useEffect(() => {
    if (chatHistoryLocalStorage.length && chatId) {
      setChatHistory(chatHistoryLocalStorage);
    }
  }, []);

  const handleSetChatItemHistory = (item: AiAssistantChatHistoryItem) => {
    setChatHistory((prev) => [...prev, item]);
  };

  const handleStartChat = async (message: string) => {
    const response = await mutationLangchainControllerChat()({
      message,
    });
    return response;
  };
  const handleResumeChat = async (message: string) => {
    if (!chatId) throw new Error("");
    const response = await mutationLangchainControllerResumeGraph()({
      graphSessionId: chatId,
      message,
    });
    return response;
  };

  const handleSendMessage = async (message: string) => {
    try {
      setIsLoading(true);
      let responseMessage: LangchainChatDto;
      const userMessage = createAiAssistantChatHistoryItem(
        message,
        AiAssistantChatMessageAuthor.USER,
      );
      handleSetChatItemHistory(userMessage);

      if (chatId) {
        const response = await handleResumeChat(message);
        responseMessage = response;
      } else {
        const response = await handleStartChat(message);
        setAiAssistantChatId(response.graphSessionId);
        responseMessage = response;
      }

      const assistantMessage = createAiAssistantChatHistoryItem(
        responseMessage?.message || "",
        AiAssistantChatMessageAuthor.ASSISTANT,
      );
      handleSetChatItemHistory(assistantMessage);
      addAiAssistantChatHistoryItem([userMessage, assistantMessage]);
    } catch (error) {
      showErrorModal(error);
      setChatHistory(chatHistoryLocalStorage);
      return message;
    } finally {
      setIsLoading(false);
    }
  };

  const handleNewChat = () => {
    clearAiAssistantChatHistory();
    setAiAssistantChatId(null);
    setChatHistory([]);
  };

  return { chatHistory, isLoading, handleSendMessage, handleNewChat };
};
